import { Checkbox, FormControlLabel, IconButton, Typography, Box } from '@mui/material';
import Switch from '@mui/material/Switch';
import capitalize from 'lodash/capitalize';
import SelectionDragIcon from 'mdi-react/SelectionDragIcon';
import { bool, func, object, string } from 'prop-types';
import React from 'react';
import { I18n } from 'utils/i18n';

const ItemCheckBox = ({
  onChange,
  name,
  value = null,
  found = null,
  onSelectionDrag,
  selected,
  onClick = () => null,
  type,
}) => {
  const error = value?.selector === 'box' && !found;
  return (
    <Box
      aria-hidden="true"
      onClick={onClick}
      sx={theme => ({
        borderRadius: '6px',
        display: 'flex',
        p: '10px',
        border: `1.5px solid ${error ? theme.palette.danger : selected ? theme.palette.primary.main : theme.palette.divider}`,
        width: '100%',
        flex: '0 0 auto',
        background: 'none',
        flexDirection: 'column',
      })}
    >
      <Box sx={{ display: 'flex' }}>
        <Checkbox
          color="primary"
          sx={{ p: '2px' }}
          name={name}
          value={!!value}
          onChange={e => {
            onChange({
              name,
              selector: type === 'xml' ? 'xpath' : 'box',
              selected: e.target.checked,
            });
          }}
          type="checkbox"
          checked={!!value}
          id={`ck-${name}`}
        />
        <Box
          component="label"
          htmlFor={`ck-${name}`}
          sx={{ display: 'block', cursor: 'pointer', textAlign: 'left', ml: '5px' }}
        >
          <Typography sx={{ fontWeight: 600 }} variant="subtitle1">
            {capitalize(I18n.t(`HrBot.fields.${name}`))}
          </Typography>
        </Box>
      </Box>
      <Box sx={{ display: 'flex', width: '100%' }}>
        <Box sx={{ width: 33, flex: '0 1 auto' }} />
        <Box
          sx={{
            flex: '1 1 auto',
            overflow: 'hidden',
            textAlign: 'left',
            '& label': {
              marginLeft: 0,
              marginRight: 0,
              '& span': {
                fontSize: 14,
              },
            },
          }}
        >
          {value && (
            <FormControlLabel
              label={I18n.t('HrBot.User defined')}
              control={
                <Switch
                  size="small"
                  onClick={e => e.stopPropagation()}
                  checked={value.selector === 'user'}
                  onChange={e => {
                    onChange({
                      ...value,
                      selected: true,
                      selector: e.target.checked ? 'user' : 'box',
                      ...(e.target.checked ? { defaultValue: 'previousMonth' } : {}),
                    });
                  }}
                />
              }
            />
          )}
          <Box
            sx={theme => ({
              display: 'flex',
              alignItems: 'center',
              color: theme.palette.secondary.main,
              overflow: 'hidden',
              '& p': {
                overflow: 'hidden',
                whiteSpace: 'nowrap',
                textOverflow: 'ellipsis',
              },
            })}
          >
            {value?.selector === 'box' && (
              <>
                {error ? (
                  <Typography color="error">{I18n.t('HrBot.not found')}</Typography>
                ) : (
                  <Typography color="secondary">{found}</Typography>
                )}
                <IconButton onClick={onSelectionDrag} sx={{ p: '5px' }} size="large">
                  <SelectionDragIcon />
                </IconButton>
              </>
            )}
            {value?.selector === 'xpath' && (
              <>
                {error ? (
                  <Typography color="error">{I18n.t('HrBot.not found')}</Typography>
                ) : (
                  <Typography color="secondary">{found}</Typography>
                )}
                <IconButton onClick={onSelectionDrag} sx={{ p: '5px' }} size="large">
                  <SelectionDragIcon />
                </IconButton>
              </>
            )}
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

ItemCheckBox.propTypes = {
  selected: bool.isRequired,
  name: string.isRequired,
  value: object,
  onChange: func.isRequired,
  found: string,
  onSelectionDrag: func.isRequired,
  onClick: func,
  type: string.isRequired,
};

export default ItemCheckBox;
